import script from "./Horizontal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Horizontal.vue?vue&type=script&setup=true&lang=ts"

import "./Horizontal.vue?vue&type=style&index=0&id=1b391de2&lang=scss"

const __exports__ = script;

export default __exports__